import React from 'react';
// import { Link } from 'react-router-dom';
//import OpvSession from 'openvidu-react';
//import OpvSession from 'components/OpenVidu/components/VideoRoomComponent';
//import PKWebSocket from 'components/PKWebSocket/PKWebSocket';
import axios from "axios";

//import 'react-chat-widget/lib/styles.css';
//import './styles.css';

import { Button, Container, Table } from 'react-bootstrap';
// , DropdownButton, Dropdown, Row, Col
import { apiUrl, user_entity_uuid, user_access_level, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// user_access_token, 
import { assembleNickname, get_current_unix_stamp } from "utils/Helper.js";

import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';

import FriendsComponent from 'components/FriendsComponent/FriendsComponent';

// import { local_routes } from 'utils/Routes';

import cloneDeep from 'lodash/cloneDeep';

//import RingTophat from 'components/Tophats/RingTophat';

//import './style.css';

import UserContext from 'store/UserContext';

//import { ZendeskAPI } from "react-zendesk";

//import { Widget, addResponseMessage, toggleWidget } from 'react-chat-widget';

//import logo from "Assets/logo.svg";

const all_calls_update_interval_time = 5000;

class VideoChatControlComponent extends React.Component {
  static contextType = UserContext;

  constructor(props) {
    console.log("AgoraVideoChatControl constructor");
    super(props);
    this.state = {
      invited_chats: [],
      //users_to_call: [],
      active_chats: [],
      all_active_chats: [],
      loading: true,
      button_loading: false
    };
    
    this.previousContext = null;
    
    this.auto_refresh_time = 10; // seconds
    
    this.all_calls_update_interval = null;
    
    
  }
  
  componentWillUnmount() {
    clearInterval(this.all_calls_update_interval);
  }
  
  /*
  resetInterval = () => {
    if (!this.interval) {
      this.interval = setInterval(() => this.APICalls(), this.auto_refresh_time * 10000);
    }
  }
  */
  
  componentDidMount = async function () {
    this.previousContext = this.context;
    if (this.context.user_info.entity_uuid) {
      console.log("AgoraVideoChatControlComponent componentDidMount",this.context.user_info.entity_uuid);
      //await this.APICalls();
      await this.updateChats();
    }
    if (user_access_level === 'admin') {
      await this.APICalls();
      this.all_calls_update_interval = setInterval(() => this.APICalls(), this.auto_refresh_time * 1000);
    }
    //ZendeskAPI("webWidget", "hide");
  }
  
  componentDidUpdate = async function (prevProps,prevState) {
    if (this.context.user_info.entity_uuid) {
      if (this.previousContext.user_info.chats !== this.context.user_info.chats) {
        this.previousContext = this.context;
        console.log("AgoraVideoChatControlComponent componentDidUpdate UPDATED CHATS",this.context.user_info.chats);
        //await this.APICalls();
        await this.updateChats();
      }
    }
  }
  
  APICalls = async function () {
    // to get all chats for admin users
    let all_active_chats_response = await axios.get(`${apiUrl}chats?index_field=public_status`,myHeaders_Auth_With_Cache_Control);
    let all_active_chat_users_promises = [];
    for (let active_chat of all_active_chats_response.data.entities) {
      all_active_chat_users_promises.push(axios.get(`${apiUrl}chats/${active_chat.entity_uuid}/users`,myHeaders_Auth_With_Cache_Control));
    }
    let all_active_chats = all_active_chats_response.data.entities;
    let all_active_chat_users_responses = await Promise.all(all_active_chat_users_promises);
    for (let i = 0; i < all_active_chat_users_responses.length; i++) {
      all_active_chats[i].invitees = [];
      all_active_chats[i].participants = [];
      
      all_active_chat_users_responses[i].data.forEach( element => {
        element.entity_name = assembleNickname(element);
        if (element.xref_data) {
          if (element.xref_data.entity_reader_integer) {
            all_active_chats[i].invitees.push(element);
          }
          if (element.xref_data.joined_time && !element.xref_data.left_time) {
            all_active_chats[i].participants.push(element);
          }
          if (element.xref_data.entity_owner_integer) {
            all_active_chats[i].inviter = element;
          }
        }
      });
    }
    let tmp_all_active_chats = all_active_chats.sort((a,b) => (a.created_time < b.created_time) ? 1 : -1);

    this.setState({
      all_active_chats: tmp_all_active_chats
    });
  }
  
  updateChats = async function () {
    //clearInterval(this.interval);
    console.log("AgoraVideoChatControlComponent updateChats");
    
    let new_state = {};

    //let lookback_time = get_current_unix_stamp() - 7200; // 120m
    //let last_active_lookback_time = get_current_unix_stamp() - 120; // 2m

    //let api_promises = [];
    /*
    // get users to call from list of followed users, and chats you have been invited to recently
    
    let api_promises = [
      axios.get(`${apiUrl}users/${user_entity_uuid}/users.audience?filter_obj=${encodeURIComponent('{"status_code":{"eq":1},"last_active_time":{"gte":'+last_active_lookback_time+'},"friended_time":{"gte":1}}')}`,myHeaders_Auth_With_Cache_Control),
      //axios.get(`${apiUrl}users/${user_entity_uuid}/chats?do_recursive=true&filter_obj=${encodeURIComponent('{"status_code":{"eq":1},"invited_time":{"gte":'+lookback_time+'}}')}`,myHeaders_Auth_With_Cache_Control),
      axios.get(`${apiUrl}users/${user_entity_uuid}/chats?do_recursive=true&filter_obj=${encodeURIComponent('{"status_code":{"eq":1},"entity_reader_integer":{"gte":1}}')}`,myHeaders_Auth_With_Cache_Control),
      axios.get(`${apiUrl}users/${user_entity_uuid}/chats?do_recursive=true&filter_obj=${encodeURIComponent('{"status_code":{"eq":1},"entity_owner_integer":{"gte":1}}')}`,myHeaders_Auth_With_Cache_Control),
    ];
    */
    /*
    if (user_access_level === 'admin') {
      // extra API calls and functionality
      api_promises = api_promises.concat([
        axios.get(`${apiUrl}users?index_field=access_level&filter_string=admin`,myHeaders_Auth_With_Cache_Control),
        axios.get(`${apiUrl}chats`,myHeaders_Auth_With_Cache_Control)
      ]);
    }
    */
    
    /*
    let followed_users_response = {
      data: Object.values({...this.context.user_info.friends})
    };
    // filter for online users
    followed_users_response.data = followed_users_response.data.filter( element => (element.is_online && element.last_active_time > (get_current_unix_stamp() - 900)) );
    */
    
    let tmp_invited_chats = [];
    let tmp_active_chats = [];
    let tmp_context_chats = cloneDeep(this.context.user_info.chats);
    
    Object.values(tmp_context_chats).forEach( element => {
      if (element.shared_access_read_uuids && element.shared_access_read_uuids.includes(user_entity_uuid)) {
        tmp_invited_chats.push(element);
      }
    });
    
    
    Object.values(tmp_context_chats).forEach( element => {
      if (element.shared_access_write_uuids && element.shared_access_write_uuids.includes(user_entity_uuid)) {
        tmp_active_chats.push(element);
      }
    });
    

    /*
    let invited_chats_response = {
      data: Object.values({...this.context.user_info.chats}).filter( element => element.shared_access_read_uuids && element.shared_access_read_uuids.includes(user_entity_uuid))
    };
    let active_chats_response = {
      data: Object.values({...this.context.user_info.chats}).filter( element => element.shared_access_write_uuids.includes(user_entity_uuid))
    };
    */
    

    //let [admin_users_response, all_active_chats_response] = await Promise.all(api_promises);

    // don't want admins in followed_users because they will be in admin array too
    //followed_users_response.data = followed_users_response.data.filter( element => element.access_level && element.access_level !== 'admin' );
    /*
    if (admin_users_response) {
      admin_users_response.data.entities = admin_users_response.data.entities.filter( element => (element.status_code === 1 && element.last_active_time && element.last_active_time > (last_active_lookback_time) && element.entity_uuid != user_entity_uuid) );
    } else {
      // fake it
      admin_users_response = {
        data: {
          entities: []
        }
      };
    }
    */
    /*
    if (!all_active_chats_response) {
      // fake it
      all_active_chats_response = {
        data: {
          entities: []
        }
      };
    }
    */
    
    /*
    followed_users_response.data.forEach( element => {
      if (element.access_level && element.access_level === 'admin') {
        element.entity_name = assembleNickname(element) + ' (friend) (admin)';
        admin_users_response.data.entities = admin_users_response.data.entities.filter( element2 => element2.entity_uuid !== element.entity_uuid);
      } else {
        element.entity_name = assembleNickname(element) + ' (friend)';
      }
    });
    */

    /*
    admin_users_response.data.entities.forEach( element => {
      element.entity_name = assembleNickname(element) + ' (admin)';
      //element.entity_name = assembleNickname(element);
    });
    */

    /*
    if (!invited_chats_response || !active_chats_response) {
      return;
    }
    */
    
    
    for (let invited_chat of tmp_invited_chats) {
      if (invited_chat.users) {
        invited_chat.participants = [];
        invited_chat.users.forEach( element => {
          //element.entity_name = assembleNickname(element);
          if (element.xref_data) {
            if (element.xref_data.entity_owner_integer) {
              invited_chat.inviter = element;
            }
            if (element.xref_data.joined_time && !element.xref_data.left_time) {
              invited_chat.participants.push(element);
            }
          }
        });
      }
      //if (invited_chat.xref_data.joined_time && !invited_chat.xref_data.left_time) {
      //  invited_chat.participants.push({entity_name:this.context.user_info.nickname,entity_uuid:user_entity_uuid});
      //}
    }
    
    
    
    for (let active_chat of tmp_active_chats) {
      if (active_chat.users) {
        active_chat.invitees = [];
        active_chat.participants = [];
        active_chat.users.forEach( element => {
          //element.entity_name = assembleNickname(element);
          if (element.xref_data) {
            if (element.xref_data.entity_reader_integer) {
              active_chat.invitees.push(element);
            }
            if (element.xref_data.joined_time && !element.xref_data.left_time) {
              active_chat.participants.push(element);
            }
          }
        });
      }
      //if (active_chat.xref_data.joined_time && !active_chat.xref_data.left_time) {
        //active_chat.participants.push({entity_name:this.context.user_info.nickname,entity_uuid:user_entity_uuid});
      //}
    }
    
    
    // if no inviter, don't show
    //invited_chats_response.data = invited_chats_response.data.filter( element => element.inviter );

    /*
    // for all active chats, get users and filter out others
    all_active_chats_response.data.entities = all_active_chats_response.data.entities.filter( element1 => {
      if (active_chats_response.data.some( element2 => element2.entity_uuid === element1.entity_uuid )) {
        return false;
      }
      if (invited_chats_response.data.some( element2 => element2.entity_uuid === element1.entity_uuid )) {
        return false;
      }
      return true;
    });
    let all_active_chat_users_promises = [];
    for (let active_chat of all_active_chats_response.data.entities) {
      all_active_chat_users_promises.push(axios.get(`${apiUrl}chats/${active_chat.entity_uuid}/users`,myHeaders_Auth_With_Cache_Control));
    }
    
    let all_active_chats = all_active_chats_response.data.entities;
    let all_active_chat_users_responses = await Promise.all(all_active_chat_users_promises);
    for (let i = 0; i < all_active_chat_users_responses.length; i++) {
      all_active_chats[i].invitees = [];
      all_active_chats[i].participants = [];
      
      all_active_chat_users_responses[i].data.forEach( element => {
        element.entity_name = assembleNickname(element);
        if (element.xref_data) {
          if (element.xref_data.entity_reader_integer) {
            all_active_chats[i].invitees.push(element);
          }
          if (element.xref_data.joined_time && !element.xref_data.left_time) {
            all_active_chats[i].participants.push(element);
          }
          if (element.xref_data.entity_owner_integer) {
            all_active_chats[i].inviter = element;
          }
        }
      });
    }
    */
    
    tmp_active_chats = tmp_active_chats.sort((a,b) => (a.created_time < b.created_time) ? 1 : -1);
    
    tmp_invited_chats = tmp_invited_chats.sort((a,b) => (a.xref_data.invited_time < b.xref_data.invited_time) ? 1 : -1);

    //let tmp_all_active_chats = all_active_chats.sort((a,b) => (a.created_time < b.created_time) ? 1 : -1);
    
    /*
    new_state.users_to_call = followed_users_response.data.concat(admin_users_response.data.entities);
    
    new_state.users_to_call = new_state.users_to_call.sort((a,b) => a.entity_name.localeCompare(b.entity_name));

    // now add possible active calls to users...if they are not already invited basically
    new_state.users_to_call.forEach( user_element => {
      user_element.possible_calls = [];
      tmp_active_chats.forEach( chat_element => {
        if (!chat_element.invitees.some( invitee_element => user_element.entity_uuid === invitee_element.entity_uuid)) {
          user_element.possible_calls.push(chat_element);
        }
      });
    });
    */
    
    //console.log("users_to_call",new_state.users_to_call);
    
    new_state.invited_chats = tmp_invited_chats;
    //console.log("invitations",new_state.invitations);
    
    new_state.active_chats = tmp_active_chats;
    //console.log("active_chats",tmp_active_chats);

    //new_state.all_active_chats = tmp_all_active_chats;
    //console.log("all_active_chats",tmp_all_active_chats);

    new_state.loading = false;
    new_state.button_loading = false;
    
    this.setState({
      ...new_state
    });
    
    //this.resetInterval();
  }

  /*
  leftCallCleanup = (chat_uuid) => {
    // update chats status with "left_time"
    this.setState({
      openvidu_session_id: '',
      openvidu_session_name: '',
      openvidu_token: '',
      current_chat_uuid: ''
    });
    
    this.props.inCallCallback(false);
    
    if (!chat_uuid) {
      return;
    }
    
    let patch_obj = {
      left_time: get_current_unix_stamp()
    }
    axios.patch(`${apiUrl}users/${user_entity_uuid}/chats/${chat_uuid}`,patch_obj);
  }
  */
  
  createChat = async () => {
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    let newWindow = window.open('about:blank', 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
    
    clearInterval(this.interval);
    
    this.setState({
      button_loading: true,
      //loading: true
    });

    // first make new PK "chat"
    let post_obj = {
      entity_name: this.context.user_info.nickname+'\'s Chat Room',
      friendly_url: this.context.user_info.nickname+'-chat-room',
      public_status: 'super_private',
      chat_type: 'party_chat'
    }
    let new_chat_response = await axios.post(`${apiUrl}chats`,post_obj);
    
    let chat_friendly_url = new_chat_response.data.friendly_url;

    newWindow.location = '/chats/'+chat_friendly_url;

    //await this.APICalls();
  }
  
  callSomebody = async (user_info) => {
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    let newWindow = window.open('about:blank', 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
  
    clearInterval(this.interval);
    
    this.setState({
      button_loading: true,
      //loading: true
    });
    
    //await this.makeCall(user_info);
    
    // first make new PK "chat"
    let post_obj = {
      entity_name: this.context.user_info.nickname+' - '+user_info.entity_name+' Chat',
      friendly_url: this.context.user_info.nickname+'-'+user_info.entity_name+'-chat',
      public_status: 'super_private',
      chat_type: 'video_chat'
    }
    let new_chat_response = await axios.post(`${apiUrl}chats`,post_obj);
    
    // need the friendly_url if it was dynamically added
    //let get_chat_response = await axios.get(`${apiUrl}chats/${new_chat_response.data.entity_uuid}`);
    
    let chat_uuid = new_chat_response.data.entity_uuid;
    //let chat_token = new_chat_response.data.openvidu_token;
    //let chat_session_id = new_chat_response.data.openvidu_session_id;
    let chat_friendly_url = new_chat_response.data.friendly_url;

    // now invite somebody to chat
    post_obj = {
      invited_time: get_current_unix_stamp(),
      entity_reader_integer: 1  
    };
    await axios.post(`${apiUrl}chats/${chat_uuid}/users/${user_info.entity_uuid}`,post_obj);

    newWindow.location = '/chats/'+chat_friendly_url;

    /*
    // open new tab for the actual chat
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    window.open('/chats/'+chat_friendly_url, 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
    */
    
    //this.APICalls();
  }
  
  inactivateCall = async (chat_info) => {
    clearInterval(this.interval);
    this.setState({
      button_loading: true
    });
    
    let patch_obj = {
      status_code: 2,
      end_time: get_current_unix_stamp()
    }
    await axios.patch(`${apiUrl}chats/${chat_info.entity_uuid}`,patch_obj);
    
    //await this.APICalls();

    
    let tmp_active_chats = this.state.active_chats.filter( element => element.entity_uuid != chat_info.entity_uuid );
    let tmp_all_active_chats = this.state.all_active_chats.filter( element => element.entity_uuid != chat_info.entity_uuid );
    this.setState({
      active_chats: tmp_active_chats,
      all_active_chats: tmp_all_active_chats,
      button_loading: false
    });
    
  }
  
  joinSession = async (chat_info) => {
    console.log("AgoraVideoChatControlComponent joinSession",chat_info);
    
    // are we invited?
    if (user_access_level === 'admin') {
      // if admin, we can invite ourselves if we need to
      if (!chat_info.shared_access_write_uuids || !chat_info.shared_access_write_uuids.includes(user_entity_uuid)) {
        // not the owner
        if (!chat_info.shared_access_read_uuids || !chat_info.shared_access_read_uuids.includes(user_entity_uuid)) {
          // not invited - invite ourselves
          let post_obj = {
            invited_time: get_current_unix_stamp(),
            entity_reader_integer: 1  
          };
          await axios.post(`${apiUrl}chats/${chat_info.entity_uuid}/users/${user_entity_uuid}`,post_obj);      
        }
      }
    }
    
    let screen_width = window.screen.width * 0.8;
    let screen_height = window.screen.height * 0.8;
    let screen_left = window.screen.width * 0.1;
    window.open('/chats/'+chat_info.friendly_url, 'PechaKucha Chat '+new Date(), 'left='+screen_left+',height='+screen_height+',width='+screen_width+',toolbar=0,location=0,menubar=0');
    
    /*
    this.setState({
      button_loading: true,
      loading: true
    });
    
    // get token
    let get_token_response = await axios.post(`${apiUrl}chats/${chat_info.entity_uuid}/getOpenViduToken`);
    */
    /*
    let session_name;
    if (chat_info.inviter) {
      session_name = chat_info.inviter.entity_name+' - '+this.context.user_info.nickname;
    } else {
      session_name = this.context.user_info.nickname+' - '+chat_info.invitees[0].entity_name;
    }
    */
    
    /*
    ZendeskAPI("webWidget", "hide");
    
    this.setState({
      ring_info: null,
      button_loading: false,
      loading: false,
      current_chat_uuid: chat_info.entity_uuid,
      openvidu_token: get_token_response.data.openvidu_token,
      openvidu_session_id: chat_info.openvidu_session_id,
      openvidu_session_name: chat_info.entity_name
    });
    */
  }

  /*
  handlerJoinSessionEvent = () => {
    // Do something
    console.log("JOINED");
    
    this.props.inCallCallback(true);
    
    let patch_obj = {
      joined_time: get_current_unix_stamp(),
      left_time: -1 // might erase previous join, but I think that is ok
    } 
    axios.patch(`${apiUrl}users/${user_entity_uuid}/chats/${this.state.current_chat_uuid}`,patch_obj);
  }
  */

  /*
  handlerLeaveSessionEvent = () => {
    // Do something
    console.log("LEFT");
    this.leftCallCleanup(this.state.current_chat_uuid);
  }

  handlerErrorEvent = (event) => {
    // Do something
    console.error("ERROR",event);
  }
  */
  
  /*
  addInvitee = async (user_info,chat_info) => {
    clearInterval(this.interval);
    this.setState({
      button_loading: true
    });

    console.log("addInvitee",user_info,chat_info);
    
    // now invite somebody to chat
    let post_obj = {
      invited_time: get_current_unix_stamp(),
      entity_reader_integer: 1  
    }
    let invite_chat_response = await axios.post(`${apiUrl}chats/${chat_info.entity_uuid}/users/${user_info.entity_uuid}`,post_obj);
    
    //await this.APICalls();
  }
  */
  
  /*
  OnRing = async (ring_info) => {
    console.log("OnRing",ring_info) ;
    this.setState({
      ring_info: ring_info
    });
    
    // now set interval to stop ringing
    this.ring_interval = setInterval(() => {
      this.setState({
        ring_info: null
      })
    }, 30000);
  }
  
  OnAnswerRing = async (chat_info) => {
    console.log("OnAnswerRing",chat_info);
    this.joinSession(chat_info);
  }
  */

  /*
  handleNewUserMessage = async (newMessage) => {
    console.log(`New message incoming! ${newMessage}`);
    // Now send the message throught the backend API
  };
  */

  render() {
    /*
    if (!this.state.allowed) {
      return (
        <Redirect to="/404" />
      );
    }
    */

    if (this.state.loading || !this.context.user_info.entity_uuid) {
      return (
        <ActivityIndicator theme="button-Status-Loader" />
      )
    }
    
    return (
      <div>

            <Container>
              <div id="join">
                  <div id="join-dialog">
                      {/*
                      <RingTophat
                        ring_info={this.state.ring_info}
                        OnAnswerRing={this.OnAnswerRing}
                      />
                      <PKWebSocket
                        user_uuid={user_entity_uuid}
                        user_token={user_access_token}
                        OnRing={this.OnRing}
                      />
                      */}
                      <h1>PechaKucha Video Chat</h1>
                      <Button
                        variant="success"
                        disabled={this.state.button_loading}
                        style={{ marginBottom: "5px", marginTop: "5px" }}
                        onClick={() => this.createChat()}
                        data-tip="Create New Chat Room"
                      >
                        New Chat Room <i className="fa fa-video-camera" aria-hidden="true"></i>
                      </Button>
                      <FriendsComponent
                        user_type='friends'
                      />
                      <FriendsComponent
                        user_type='admins'
                      />
                      {/*
                      <Table
                        striped
                        bordered
                        hover
                        variant={this.context.theme === 'dark' ? 'dark' : ''}
                      >
                        <thead>
                          <tr>
                            <th>Last Active Date/Time</th>
                            <th>User</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                        { this.state.users_to_call.map( user_element => (
                          <tr key={user_element.entity_uuid}>
                            <td>{new Date(user_element.last_active_time * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</td>
                            <td>
                              <Link to={local_routes.users+'/'+user_element.friendly_url}>
                                {user_element.entity_name}
                              </Link>
                            </td>
                            <td>
                              <Button variant="success" disabled={this.state.button_loading} onClick={() => this.callSomebody(user_element)}>Start New Call</Button>&nbsp;
                              { user_element.possible_calls.length > 0 &&
                              <DropdownButton variant="pkprimary" disabled={this.state.button_loading} className="d-inline-block" title="Add to Call">
                                { user_element.possible_calls.map( chat_element => (
                                  <Dropdown.Item key={chat_element.entity_uuid} onClick={() => this.addInvitee(user_element,chat_element)}>{chat_element.entity_name}</Dropdown.Item>  
                                ))}
                              </DropdownButton>
                              }
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </Table>
                      */}
                      <h1>Available Calls to Join</h1>
                      <Table
                        striped
                        bordered
                        hover
                        variant={this.context.theme === 'dark' ? 'dark' : ''}
                      >
                        <thead>
                          <tr>
                            <th>Invited Date/Time</th>
                            <th>Call Name</th>
                            <th>Host</th>
                            <th>Current Participants</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                        { this.state.invited_chats.map( element => (
                          <tr key={element.entity_uuid}>
                            <td>{new Date(element.xref_data.invited_time * 1000).toLocaleString()}</td>
                            <td>{element.entity_name}</td>
                            <td>{element.inviter.entity_name}</td>
                            <td>{element.participants.map( element => element.entity_name ).join(', ')}</td>
                            <td>
                              <Button variant="success" disabled={this.state.button_loading || element.participants.some( element2 => element2.entity_uuid === user_entity_uuid)} onClick={() => this.joinSession(element)}>Join Call</Button>
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </Table>
                      <h1>Your Active Calls</h1>
                      <Table
                        striped
                        bordered
                        hover
                        variant={this.context.theme === 'dark' ? 'dark' : ''}
                      >
                        <thead>
                          <tr>
                            <th>Created Date/Time</th>
                            <th>Call Name</th>
                            <th>Invitees</th>
                            <th>Current Participants</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                        { this.state.active_chats.map( element => (
                          <tr key={element.entity_uuid}>
                            <td>{new Date(element.created_time * 1000).toLocaleString()}</td>
                            <td>{element.entity_name}</td>
                            <td>{element.invitees.map( element => element.entity_name ).join(', ')}</td>
                            <td>{element.participants.map( element => element.entity_name ).join(', ')}</td>
                            <td>
                              <Button variant="success" disabled={this.state.button_loading || element.participants.some( element2 => element2.entity_uuid === user_entity_uuid)} onClick={() => this.joinSession(element)}>Join Call</Button>&nbsp;
                              <Button disabled={this.state.button_loading} variant="danger" onClick={() => this.inactivateCall(element)}>End Call</Button>
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </Table>
                      { user_access_level === 'admin' &&
                      <React.Fragment>
                        <h1>All Active Calls</h1>
                        <Table
                          striped
                          bordered
                          hover
                          variant={this.context.theme === 'dark' ? 'dark' : ''}
                        >
                          <thead>
                            <tr>
                              <th>Created Date/Time</th>
                              <th>Call Name</th>
                              <th>Host</th>
                              <th>Invitees</th>
                              <th>Current Participants</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                          { this.state.all_active_chats.map( element => (
                            <tr key={element.entity_uuid}>
                              <td>{new Date(element.created_time * 1000).toLocaleString()}</td>
                              <td>{element.entity_name}</td>
                              <td>{element.inviter.entity_name}</td>
                              <td>{element.invitees.map( element => element.entity_name ).join(', ')}</td>
                              <td>{element.participants.map( element => element.entity_name ).join(', ')}</td>
                              <td>
                                <Button variant="success" disabled={this.state.button_loading || element.participants.some( element2 => element2.entity_uuid === user_entity_uuid)} onClick={() => this.joinSession(element)}>Join Call</Button>&nbsp;
                                <Button disabled={this.state.button_loading} variant="danger" onClick={() => this.inactivateCall(element)}>End Call</Button>
                              </td>
                            </tr>
                          ))}
                          </tbody>
                        </Table>
                        {/*
                        <h1>Text Chat</h1>
                          <Button onClick={toggleWidget}/>
                          <Widget
                            handleNewUserMessage={this.handleNewUserMessage}
                            profileAvatar={this.context.user_info.adjusted_image_url || null}
                            title="My new awesome title"
                            subtitle="And my cool subtitle"
                          />
                        */}
                      </React.Fragment>
                      }
                  </div>
              </div>
            </Container>

      </div>

    );
  }
}

export default VideoChatControlComponent;



